import { defineMessage } from 'services/localization';

export const messages = {
    successfulMessage: defineMessage('has_been_successfully_copied_to'),
    existingRequestsNode: defineMessage('please_note_that_the_up__past_existing_requests'),
    activateWorkflow: defineMessage('dont_forget_to_activate_your_workflow'),
    done: defineMessage('done'),
};
